import { StyleSheet } from "react-native";
import { fonts } from "../../styles/theme";

const SignInStyle = StyleSheet.create({
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    zIndex: 1000,
  },
  containerBtn: {
    // flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  hiddenButton: {
    position: "absolute",
    opacity: 0,
  },

  customButtonText: {
    color: "white",
    fontSize: 16,
    //fontWeight: "bold",
    fontFamily: fonts.medium,
  },
  container: {
    flex: 1,
    backgroundColor: "#fff",
  },
  header: {
    backgroundColor: "#3629B7",
    paddingHorizontal: 20,
    display: "flex",
    flexDirection: "column",
    height: 250,
    marginBottom: -30,
    justifyContent: "center",
    paddingBottom: 15,
  },
  headerText: {
    color: "#fff",
    fontSize: 24,
    //fontWeight: "600",
    fontFamily: fonts.regular,
  },
  content: {
    flex: 1,
    paddingHorizontal: 20,
    paddingVertical: 30,
    borderTopRightRadius: 25,
    borderTopLeftRadius: 25,
    backgroundColor: "#ffF",
  },
  subHeaderText: {
    color: "#fff",
    fontSize: 30,
    fontFamily: fonts.regular,
  },
  welcomeText: {
    fontSize: 24,
    //fontWeight: "600",
    color: "#3629B7",
    marginBottom: 5,
    fontFamily: fonts.medium,
  },
  subText: {
    color: "#343434",
    marginBottom: 20,
    fontFamily: fonts.regular,
  },
  imageContainer: {
    // flex:2,
    flexDirection: "column",
    alignItems: "center",
    // width: "100%",
    // height: 150,
    // marginVertical: 20,
  },
  images: {
    width: 200,
    height: 200,
  },
  signinContainer: {
    flexDirection: "row",
    alignItems: "center",
    borderWidth: 3,
    borderColor: "#4F46E5",
    borderRadius: 8,
    height: 66,
    overflow: "hidden",
    width: 390,
  },
  image: {
    width: 50,
    height: 50,
    marginLeft: 10,
    marginRight: 10,
    backgroundColor: "white",
  },
  signButton: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#4F46E5",
    height: "100%",
  },
  signText: {
    textAlign: "center",
    fontSize: 24,
    color: "white",
    fontFamily: fonts.regular,
  },
});

export default SignInStyle;
